import {Breadcrumb as PeacockBreadcrumb} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IBreadcrumbProps} BreadcrumbProps
 * @property {{ label: string | import('react').ReactNode; href?: string; onClick?: () => void; }[]} [breadcrumbs] The list to populate the Breadcrumbs.
 * @property {number} [maxBreadcrumbCount] Maximum number of breadcrumbs to display before collapsing into a dropdown. If not provided, all breadcrumbs will be displayed.
 * @property {boolean} [useAnchor] If true, render the breadcrumb as an anchor tag. Defaults to true.
 * @property {import('@pepsico-ds/ui').IButtonIconProps} [homeIcon] The home icon displayed as the first breadcrumb item. Defaults to home.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Breadcrumb.
 * Supports all Peacock DS breadcrumb props.
 * @param {BreadcrumbProps} props
 */
export const Breadcrumb = props => {
  return <PeacockBreadcrumb {...props} />
}
